class GuidGenerator {
  createId(prefix) {
    if(prefix) {
      return prefix + '_' + this.guid();
    }
    return this.guid();
  }
  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
}

const guid = new GuidGenerator();

export default guid;
